import { isPlainObject } from 'shared/utils/object';

/**
 * Health check of the service worker over `ServiceWorker.postMessage` (which
 * starts a stopped worker): the page posts `request` with a transferred port,
 * the worker answers on that port with a `ServiceWorkerHealthReport`. It works
 * when broadcast channels are silent, so it explains a missing response.
 */
export enum ServiceWorkerHealthMessageType {
  request = 'HUSTRO_SW_HEALTH_REQUEST',
}

/** Where the last pull of an entity got to and how long ago. */
export interface PullStepReport {
  step: string;
  ageMs: number;
}

export interface ServiceWorkerHealthReport {
  /** Version of the worker's script; differs from the page's after a deploy until the update. */
  swVersion: string;
  /** A small uptime means the worker was just (re)started. */
  swUptimeMs: number;
  hasTokenInMemory: boolean;
  /**
   * Keys the stored config lacks (all of them without a config): no project
   * data is downloaded without them. `null` when the config could not be read.
   */
  missingConfigKeys: string[] | null;
  /** The last step of each entity's pull in this worker session, by the entity's contract key. */
  pullSteps: Record<string, PullStepReport>;
  authCooldownRemainingMs: number;
  /** `null` when the API is not available. */
  online: boolean | null;
  pendingHttpRequests: number | null;
  httpRequestInProgress: boolean;
  requestsSuspended: boolean;
  rateLimitRemainingMs: number;
}

export function isServiceWorkerHealthRequest(data: unknown): boolean {
  return (
    isPlainObject(data) && data.type === ServiceWorkerHealthMessageType.request
  );
}
